module.exports = __webpack_public_path__ + "img/NOWCLOSED-TANAKA.eabb89f5.gif";